import SettingsService from '_services/rest/modules/settings';
import AccessControlService from '_services/rest/modules/accessControl';

export default {
  state: {
    company: null,
    messages: null,
    settings: null,
    results: {
      noise: null,
      chemical: null,
    },
    riskClassifications: {
      vibration: null,
    },
    validation: {
      noise: null,
    },
    roles: null,
    userTypes: null,
  },
  mutations: {
    setCompany(state, response) {
      state.company = response;
    },
    setMessages(state, response) {
      state.messages = response;
    },
    setSettings(state, response) {
      state.settings = response;
    },
    setRoles(state, response) {
      state.roles = response || [];
    },
    setUserTypes(state, response) {
      state.userTypes = response || [];
    },
    setResults(state, response) {
      state.results = response;
    },
    setRiskClassifications(state, response) {
      state.riskClassifications = response;
    },
    setValidation(state, response) {
      state.validation = response;
    },
    addRole(state, option) {
      state.roles.push(option);
    },
  },
  actions: {
    getSettings({ commit }) {
      return SettingsService.getSettings()
        .then(response => {
          commit('setCompany', response.company);
          commit('setMessages', response.message);
          commit('setSettings', response.settings);
          commit('setResults', response.result);
          commit('setRiskClassifications', response.riskClassification);
          commit('setValidation', response.validation);
        });
    },
    getRoles({ commit }) {
      return AccessControlService.getRoles()
        .then(response => {
          commit('setRoles', response);
        });
    },
    getUserTypes({ commit }) {
      return AccessControlService.getTypes()
        .then(response => {
          commit('setUserTypes', response);
        });
    },
    addRole({ commit }, params) {
      commit('addRole', params);
    },
  },
};
